var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 185 302.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 137,
    y1: 1.33,
    x2: 137.35,
    y2: 81.74,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fe4ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8de4ff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cdcff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 116.19,
    y1: 154.47,
    x2: 146.95,
    y2: 154.96,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#749494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7d8ba3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 125.07,
    y1: 122.67,
    x2: 147.45,
    y2: 122.67,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ed4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a2dafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3c8efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1457b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b55c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 126.03,
    y1: 66.71,
    x2: 147.75,
    y2: 66.71,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a2afb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#68787f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 136.43,
    y1: 71.65,
    x2: 137.56,
    y2: 66.3,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ad2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2b72d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 136.43,
    y1: 65.91,
    x2: 137.56,
    y2: 60.56,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ad2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2b72d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 47.99,
    y1: 1.33,
    x2: 48.34,
    y2: 81.74,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fe4ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8de4ff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cdcff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 27.18,
    y1: 154.47,
    x2: 57.95,
    y2: 154.96,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#749494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7d8ba3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 36.3,
    y1: 122.02,
    x2: 58.68,
    y2: 122.02,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ed4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a2dafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3c8efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1457b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b55c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 37.23,
    y1: 66.71,
    x2: 58.96,
    y2: 66.71,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a2afb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#68787f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 47.73,
    y1: 71.66,
    x2: 48.85,
    y2: 66.29,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ad2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2b72d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 47.73,
    y1: 65.92,
    x2: 48.85,
    y2: 60.56,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ad2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2b72d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3289"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 92.87,
    y1: 2.58,
    x2: 93.4,
    y2: 125.63,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7cb59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffed8d",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbaf1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 34.11,
    y1: 202.75,
    x2: 141.45,
    y2: 173.8,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffe24c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f37649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b85b3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 6.1,
    y1: 125.62,
    x2: 165.21,
    y2: 125.37,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#42d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#d6d8dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#768294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b2b8c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1257bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 75.63,
    y1: 145.04,
    x2: 110.17,
    y2: 145.04,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a2afb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#68787f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 68.35,
    y1: 73.78,
    x2: 91.06,
    y2: 73.78,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a2afb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#68787f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 69.26,
    y1: 57.6,
    x2: 89.06,
    y2: 57.6,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ed4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a2dafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3c8efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1457b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b55c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 93.81,
    y1: 73.73,
    x2: 116.52,
    y2: 73.73,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a2afb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#68787f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 94.69,
    y1: 57.6,
    x2: 114.5,
    y2: 57.6,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ed4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a2dafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3c8efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1457b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b55c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 51.78,
    y1: 196.78,
    x2: 103.56,
    y2: 196.78,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ed4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#a2dafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3a7ad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b55c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 90.6,
    y1: 83.51,
    x2: 93.8,
    y2: 83.51,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8edee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d9eded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7e8d90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 78.6,
    y1: 161.96,
    x2: 106.54,
    y2: 135.52,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c2850b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f96f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#76280c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 87.85,
    y1: 160.05,
    x2: 97.63,
    y2: 134.58,
    gradientTransform: "translate(0 303.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffb800"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "right_rocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right_fire",
    d: "m137.11,231.16h.64l47.25,70.97h-95.99l48.1-70.97Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,89.1v140.62h-21.75V89.1c-.01-.3,0-.6.06-.89.6-6.46,7.18-19.73,10.82-19.73s10.23,13.26,10.81,19.73c.05.29.07.59.06.89Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,180.65h-21.75v1.32h21.75v-1.32Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,100.51h-21.75v1.32h21.75v-1.32Z",
    style: {
      fill: "rgba(255, 255, 255, .4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,109.96h-21.75v1.32h21.75v-1.32Z",
    style: {
      fill: "rgba(255, 255, 255, .4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,229.78h-21.75v13.2c0,.47.19.93.53,1.26.34.33.79.52,1.26.53h18.11c.48,0,.93-.19,1.27-.52.34-.34.53-.79.53-1.27v-13.2h.06Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,236.41h-21.75c-.44-.03-.86-.22-1.16-.55-.3-.32-.47-.75-.47-1.19s.17-.87.47-1.19c.3-.32.72-.52,1.16-.55h21.75c.46,0,.9.18,1.22.51.32.33.51.77.51,1.23,0,.23-.04.46-.12.67-.08.21-.21.41-.37.57-.16.16-.35.29-.57.38-.21.09-.44.13-.67.12Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.75,242.15h-21.75c-.44-.03-.86-.22-1.16-.55-.3-.32-.47-.75-.47-1.19s.17-.87.47-1.19c.3-.32.72-.52,1.16-.55h21.75c.46,0,.9.19,1.22.51.32.32.51.77.51,1.23,0,.23-.04.46-.12.67-.09.21-.21.4-.38.57-.16.16-.35.29-.57.38-.21.08-.44.13-.67.12Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "left_rocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left_fire",
    d: "m48.1,231.16h.64l47.25,70.97H0l48.1-70.97Z",
    style: {
      fill: "url(#linear-gradient-7)",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.74,89.1v140.62h-21.75V89.1c0-.3,0-.6.06-.89.6-6.46,7.18-19.73,10.82-19.73s10.23,13.26,10.81,19.73c.05.29.07.59.06.89Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.99,181.31h-21.75v1.32h21.75v-1.32Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.99,100.51h-21.75v1.32h21.75v-1.32Z",
    style: {
      fill: "rgba(255, 255, 255, .4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.99,109.96h-21.75v1.32h21.75v-1.32Z",
    style: {
      fill: "rgba(255, 255, 255, .4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.99,229.78h-21.75v13.2c0,.48.19.93.53,1.27.34.34.79.52,1.27.52h18.11c.24,0,.47-.05.69-.14.22-.09.41-.22.58-.39.17-.17.3-.36.39-.58.09-.22.14-.45.14-.68v-13.2h.06Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.99,236.41h-21.75c-.44-.03-.85-.22-1.16-.55-.3-.32-.47-.75-.47-1.19s.17-.87.47-1.19c.3-.32.72-.52,1.16-.55h21.75c.24-.01.48.02.7.1.22.08.43.21.6.37.17.16.31.36.41.58.09.22.14.45.14.69s-.05.47-.14.69c-.09.22-.23.41-.41.58-.17.16-.38.29-.6.37-.22.08-.46.11-.7.1Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.99,242.15h-21.75c-.44-.03-.85-.22-1.16-.55-.3-.32-.47-.75-.47-1.19s.17-.87.47-1.19c.3-.32.72-.52,1.16-.55h21.75c.24-.01.48.02.7.1.22.08.43.21.6.37.17.16.31.36.41.58.09.22.14.45.14.69s-.05.47-.14.69c-.09.22-.23.41-.41.58-.17.16-.38.29-.6.37-.22.08-.46.11-.7.1Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "main_rocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "main_fire",
    d: "m93.02,191.99h.91l66.94,108.65H24.87l68.15-108.65Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.26,47.27h.12c-.06.78-.12,1.46-.12,2.19v-2.19Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.46,47.27v2.19c0-.73-.06-1.46-.12-2.19h.12Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.51
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.58,49.46v168.88c0,6.31-5.11,11.42-11.42,11.42h-29.33c-6.31,0-11.42-5.11-11.42-11.42V49.46c0-.73.06-1.46.12-2.19C68.03,31.79,83.74,0,92.53,0c9.2,0,24.48,31.79,25.94,47.27.06.77.12,1.46.12,2.19Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.73,63.46h-52.14v1.34h52.11l.03-1.34Z",
    style: {
      fill: "rgba(255, 255, 255, .6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.73,72.9h-52.14v1.32h52.11l.03-1.32Z",
    style: {
      fill: "rgba(255, 255, 255, .6)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ship"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.17,229.78H31.41c.77-6.52,1.91-12.97,4.84-19,1.87-3.6,4.27-6.9,7.11-9.8,2.81-3.05,5.8-5.92,8.55-9.02,5.62-6.38,10.45-13.4,14.4-20.92,3.68-7.17,6.36-14.81,7.95-22.71,1.53-6.96,2.29-14.06,2.27-21.19h32.44c-.02,7.13.74,14.23,2.27,21.19,1.62,7.89,4.3,15.53,7.96,22.7,3.92,7.54,8.75,14.57,14.4,20.92,2.75,3.11,5.74,5.97,8.55,9.03,2.81,3.05,5.38,6.15,7.11,9.8,3,5.98,4.13,12.43,4.91,19.01Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.17,122.2v107.33h-34.54v-107.33c0-.49.01-.98.06-1.46.96-10.58,7.17-32.39,17.21-32.39,9.21,0,16.26,21.81,17.22,32.39,0,.5.06,1.06.06,1.46Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.54,215.85h6.52v28.71h-22.71v-12.55c0-2.12.42-4.23,1.24-6.19.81-1.96,2.01-3.75,3.51-5.25,1.5-1.5,3.29-2.69,5.25-3.5,1.96-.81,4.07-1.22,6.19-1.22Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.33,244.56h-19.25c0,.97.38,1.9,1.07,2.58.69.69,1.61,1.07,2.58,1.07h11.95c.97,0,1.89-.39,2.57-1.07.68-.68,1.06-1.61,1.06-2.58Z",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.32,215.91h-6.52v28.69h22.71v-12.55c-.03-4.28-1.74-8.38-4.77-11.4-3.03-3.02-7.14-4.73-11.42-4.74Z",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.16,248.21h11.95c.97,0,1.9-.38,2.58-1.07.69-.68,1.07-1.61,1.07-2.58h-19.25c0,.97.38,1.9,1.07,2.58.68.68,1.61,1.07,2.58,1.07Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.31,109.24v3.94c-3.17-2.56-6.69-4.18-10.52-4.18-3.82.07-7.52,1.39-10.51,3.76v-4.06c.71-1.12,1.51-2.18,2.39-3.17,2.33-2.62,5.11-4.3,8.13-4.3,2.81,0,5.44,1.67,7.77,4.3,1.03,1.15,1.95,2.4,2.75,3.71Z",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.34,194.51c.39,0,.76.15,1.03.43.27.27.43.65.43,1.03v48.96c0,.39-.15.76-.43,1.03-.27.27-.65.43-1.03.43s-.76-.15-1.03-.43c-.27-.27-.43-.65-.43-1.03v-48.96c0-.39.15-.76.43-1.03.27-.27.65-.43,1.03-.43Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.27,154.36l6.62.03-.03.05-8.37,14.94,3.22-13.27-6.41,2.37-2.3.67,2.81-4.16,11.66-14.99-6.48,13.31-.72,1.06Z",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.06,150.56l-2.55,3.83-.03.05-9.99,14.94,4.84-13.27-8.2,2.42,2.3-3.54,10.03-14.99-4.86,13.31,8.45-2.74Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullRocket);
export default __webpack_public_path__ + "static/media/full_rocket.29871f02664e0c2f9a52b586d26c368a.svg";
export { ForwardRef as ReactComponent };